<template>
  <v-row class="mt-1">
    <v-col>
      <div class="font-size-x-small my-3 text-red" v-if="role && disabled">
        <v-icon size="small">mdi-alert</v-icon>
        {{ $t('user.forms.editUserForm.messages.thisUserRoleCannotBeWarehouseRestricted') }}
      </div>
      <template v-if="!disabled">
        <v-switch
          color="primary"
          :model-value="modelValue"
          :readonly="readOnly"
          :disabled="readOnly"
          @update:model-value="val => $emit('update:model-value', val)"
          hide-details="auto">
          <template v-slot:label>
            <v-tooltip location="top">
              <template v-slot:activator="{ props }">
                <div v-bind="props">
                  {{
                    $t(
                      'user.forms.editUserForm.messages.restrictThisUsersPermissionsToSpecificWarehouses'
                    )
                  }}
                </div>
              </template>
              <div class="tight-tooltip-content">
                <div>
                  <strong>{{ $t('user.forms.editUserForm.tooltips.restrictedUser') }}:</strong>
                  {{
                    $t(
                      'user.forms.editUserForm.tooltips.permissionsWillOnlyBeAllowedInSelectedWarehouses'
                    )
                  }}.
                </div>
                <div class="mt-2">
                  <strong>{{ $t('user.forms.editUserForm.tooltips.unrestrictedUser') }}:</strong>
                  {{
                    $t(
                      'user.forms.editUserForm.tooltips.permissionsWillBeAllowedInAllWarehousesThisAlsoIncludesWarehousesThatMayBeCreatedInTheFuture'
                    )
                  }}.
                </div>
              </div>
            </v-tooltip>
          </template>
        </v-switch>
      </template>
    </v-col>
  </v-row>
</template>

<script>
export default {
  props: {
    modelValue: {
      type: Boolean,
      required: false,
      default: false
    },
    readOnly: {
      type: Boolean,
      required: false,
      default: false
    },
    role: {
      type: String,
      required: true
    }
  },
  computed: {
    disabled() {
      return !this.novaCore.canUserRoleHaveWarehouseAccessList(this.role);
    }
  }
};
</script>
